import { useState } from "react";
import { useAccountEffect } from "wagmi";
function useBitcoinAccount() {
    const [btcAddress, setBtcAddress] = useState(undefined);
    const [btcBalance, setBtcBalance] = useState(undefined);
    useAccountEffect({
        onConnect: async ({ connector }) => {
            if (connector.type !== "orangekit")
                return;
            const provider = connector.getBitcoinProvider();
            const address = await provider.getAddress();
            const balance = await provider.getBalance();
            setBtcAddress(address);
            setBtcBalance(balance);
        },
    });
    return { btcAddress, btcBalance };
}
export { useBitcoinAccount };
//# sourceMappingURL=useBitcoinAccount.js.map